import { api } from './api';

export interface DailyStats {
  date: string;
  sessions: number;
  conversions: number;
  bounce_rate: number;
  avg_time_on_page: number;
}

export interface Session {
  id: string;
  session_id: string;
  language: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  referrer?: string;
  device_type?: string;
  converted: number;
  conversion_type?: string;
  started_at: string;
  events?: Array<{ event_type: string; event_data?: Record<string, unknown>; created_at: string }>;
}

export interface ABVariant {
  id: string;
  variant_id: string;
  name: string;
  element: string;
  content: string;
  language: string;
  status: 'active' | 'inactive';
  impressions: number;
  conversions: number;
  conversion_rate: number;
  thompson_probability?: number;
  created_at: string;
}

export interface BridgeRow {
  niche: string;
  sessions: number;
  conversions: number;
  conversion_rate: number;
  top_rewrite_id?: string | number;
}

export interface CreateVariantInput {
  variant_id: string;
  name: string;
  element: string;
  content: string;
  language?: string;
}

export interface StatsResponse {
  daily: DailyStats[];
  totals: {
    sessions: number;
    conversions: number;
    bounce_rate: number;
    avg_time_on_page: number;
    traffic_sources: Record<string, number>;
    device_split: Record<string, number>;
  };
}

export interface SessionsResponse {
  sessions: Session[];
  total: number;
  page: number;
}

export interface ABTestsResponse {
  variants: ABVariant[];
}

export const lpAnalyticsApi = {
  getStats: (start: string, end: string) =>
    api.get<StatsResponse>(`/lp-analytics/stats?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`),

  getSessions: (page: number) =>
    api.get<SessionsResponse>(`/lp-analytics/sessions?page=${page}`),

  getABTests: () =>
    api.get<ABTestsResponse>('/lp-analytics/ab'),

  createVariant: (data: CreateVariantInput) =>
    api.post<ABVariant>('/lp-analytics/ab/variants', data),

  updateVariant: (id: string, data: { status: 'active' | 'inactive' }) =>
    api.patch<ABVariant>(`/lp-analytics/ab/variants/${id}`, data),

  getBridge: (days = 30) =>
    api.get<BridgeRow[]>(`/lp-analytics/bridge?days=${days}`),
};
